// extracted by mini-css-extract-plugin
export var wrapper = "section-module--wrapper--M-nIU";
export var background = "section-module--background--YMMzU";
export var content = "section-module--content--zJLaP";
export var form = "section-module--form--mFB3Q";
export var fadein = "section-module--fadein--IW2FT";